const C = {
  name: "ZoomOut",
  dimensions: { width: 41, height: 41 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M38.7051 37.71C38.3151 38.1 37.6851 38.1 37.2951 37.71L27.5651 27.99C28.0651 27.55 28.5351 27.08 28.9751 26.58L38.7051 36.31C39.0951 36.68 39.0951 37.32 38.7051 37.71ZM2.99512 16C2.99512 8.28 9.27512 2 16.9951 2C24.7151 2 30.9951 8.28 30.9951 16C30.9951 23.72 24.7151 30 16.9951 30C9.27512 30 2.99512 23.72 2.99512 16ZM40.1151 34.88L30.2251 24.99C31.9751 22.42 32.9951 19.33 32.9951 16C32.9951 7.18 25.8151 0 16.9951 0C8.17512 0 0.995117 7.18 0.995117 16C0.995117 24.82 8.17512 32 16.9951 32C20.3251 32 23.4151 30.98 25.9851 29.23L35.8751 39.12C36.4551 39.71 37.2251 40 37.9951 40C38.7651 40 39.5351 39.71 40.1151 39.12C41.2851 37.95 41.2851 36.05 40.1151 34.88Z"/>
        <path d="M20.9951 15H12.9951C12.4451 15 11.9951 15.45 11.9951 16C11.9951 16.55 12.4451 17 12.9951 17H20.9951C21.5451 17 21.9951 16.55 21.9951 16C21.9951 15.45 21.5451 15 20.9951 15Z"/>
    </g>
  `
};
export {
  C as ZoomOut
};
